import { AfterViewInit, Component, EventEmitter, HostListener, OnInit, Output, ViewChild } from "@angular/core";
import { Campaign3BreadcrumbComponent } from "../components/campaign-3-breadcrumb/campaign-3-breadcrumb.component";
import { BreadCrumbModel } from "../models/campaign-3-breadcrumb.model";
import { Campaign2Service } from "app/services/campaign-2.0/campaign2.service";
import { Campaign3Service } from "../services/campaign3.service";
import { KontableComponent } from "app/modules/UIKit/components/kontable/kontable.component";
import { Router } from "@angular/router";
import { Campaign3TestService } from "../services/campaign3testservice";
import { Observable } from "rxjs";
import { Campaign3Campaign } from "../models/campaign-3.model";
import { CalendarTranslateService } from "app/modules/UIKit/services/calendarTranslate.service";
import { ActionStateService } from "../services/actionstate.service";
import { Campaign3KontableComponent } from "../components/campaign-3-kontable/campaign-3-kontable.component";
import { AuthService } from "app/services/user/auth.service";
import { LoyaltyAcmService } from "app/services/loyalty/loyalty-acm.service";

@Component({
    selector: 'app-action-list-3',
    templateUrl: './action-list-3.component.html',
    styleUrls: ['./action-list-3.component.css']
})
export class ActionList3Component implements OnInit {


    @ViewChild('breadcrumbComponent') breadcrumb: Campaign3BreadcrumbComponent;
    @ViewChild('actionlist') kontableComponent: Campaign3KontableComponent;

    breadcrumbs: Array<BreadCrumbModel> = [];
    paginationType = KontableComponent.ServerPagination;
    dateFilter = KontableComponent.DateFilter;
    numberFilter = KontableComponent.NumberFilter;
    textFilter = KontableComponent.TextFilter;
    selectFilter = KontableComponent.SelectFilter;
    noFilter = KontableComponent.NoFilter;
    pageSubject = "actions";
    actionTypes: Array<{ label: string, value: string, code: string }>;
    actionStatusList: Array<{ label: string, value: string }>;

    campaignType: Array<{ label: string, value: string }>;
    statusList: Array<{ label: string, value: string }>;
    budgetList: Array<{ label: string, value: string }>;


    showPopupCreate: boolean = false;
    infoAction = true;
    showMenu = false;
    readyTable = false;
    showPopupInfo = false;
    startDate;
    endDate;
    campaignId: number;
    currentOpenedRow;
    campaignList: Array<Campaign3Campaign> = [];
    singleAction: any;
    language: string = "it";

      acmNoBurned :Array<any>



    constructor(
        public campaign2Service: Campaign2Service,
        public campaign3Service: Campaign3Service,
        public testService: Campaign3TestService,
        public router: Router,
        public srvCalendar: CalendarTranslateService,
        public actionStateService: ActionStateService,
        private authService: AuthService,
               private srvLoyaltyAcm: LoyaltyAcmService,
    ) { }


    ngOnInit(): void {


        this.actionTypes = [];
        this.actionStatusList = [];
        this.campaignType = [];
        this.statusList = [];
        this.budgetList = [];
        this.campaignType.push({ label: '', value: null });
        this.statusList.push({ label: '', value: null });
        this.language = this.authService.sessionHelper.selectedLanguage;
        this.initBreadCrumbs();
        const campaignTipeSub = this.testService.getCampaignType();
        const statusSub = this.testService.getCampaignStatus();
        const budgetSub = this.testService.getBudgetType();
        const actionTipeSub = this.testService.getActionTypes();
        const actionstatusSub = this.testService.getActionStatus();
        const CAMPAIGN_LIST = this.testService.getAllCampaigns();
          const LISTA_ACCUMULATORI = this.srvLoyaltyAcm.getAllAcmNoBurned();


        this.actionTypes.push({ label: '', value: null, code: "" });
        this.actionStatusList.push({ label: '', value: null });

        Observable.zip(
            actionTipeSub,
            actionstatusSub,
            CAMPAIGN_LIST,
            campaignTipeSub,
            statusSub,
            budgetSub,
            LISTA_ACCUMULATORI
        ).subscribe(
            ([resActionType, resActionStatus, resCampaignList, resCampaignType, resCampaignStatus, resCampaignBudgettype,res_acc]) => {
                if (resActionType && resActionStatus) {
                    for (const action of resActionType.data) {
                        this.actionTypes.push({ label: action.description, value: action.id.toString(), code: action.code });
                    }
                    for (const actionStatus of resActionStatus.data) {
                        this.actionStatusList.push({ label: actionStatus.description, value: actionStatus.id.toString() });
                    }
                    for (const campaignType of resCampaignType.data) {
                        this.campaignType.push({ label: campaignType.description, value: campaignType.id.toString() });
                    }
                    for (const status of resCampaignStatus.data) {
                        this.statusList.push({ label: status.description, value: status.id.toString() });
                    }
                    for (const campaignBudget of resCampaignBudgettype.data) {
                        this.budgetList.push({ label: campaignBudget.description, value: campaignBudget.id.toString() });
                    }


                }
                if (resCampaignList && resCampaignList.length > 0) {
                    this.campaignList = resCampaignList;
                }
                this.readyTable = true;
                setTimeout(() => {
                    const currentActionId = this.actionStateService.getCurrentActionId();
                    if (currentActionId) {
                      
                        this.kontableComponent.findAgainAction(currentActionId);
                        this.actionStateService.setCurrentActionId(null);
                    }

                }, 100);

                if(res_acc){
                      // Lista accumulatori non bruciati
                    this.acmNoBurned = res_acc;
                }



            },
        );
    }



    clearDateFields() {
        this.startDate = null;
        this.endDate = null;
    }

    initBreadCrumbs() {
        let bc1 = new BreadCrumbModel();
        bc1.code = "bc1";
        bc1.description = "Azioni";
        bc1.routerLink= "/action-list-3";
     
        this.breadcrumbs.push(bc1);
  
    }

    onCampaignTable() {
        this.router.navigate(["/campaign-list-3"]);
    }

    onOpenCreation() {
        this.showPopupCreate = !this.showPopupCreate;
    }

    onOpenInfoAction(id: number | undefined) {
        if (id === undefined) {
            console.error("ID is undefined!");
            return;
        }
        this.statusAction(id);
        if (!this.showPopupInfo) {
            this.fetchSingleAction(id);
        }
    }

    fetchSingleAction(id: number) {
        this.testService.getSingleAction(id).subscribe(
            (res) => {
                this.singleAction = res;
                this.showPopupInfo = true;
            }
        )
    }

    statusAction(id: number) {
        this.testService.fetchActionStatus(id).subscribe(
            res => {
                console.log("status value actions:", res)
            }
        )
    }

    onClosePopupInfo() {
        this.showPopupInfo = false;
    }

    toggleMenu(id: number) {


        if (this.showMenu && this.currentOpenedRow !== id) {
            this.showMenu = false;
        }

        this.currentOpenedRow = id;
        this.showMenu = !this.showMenu;
    }
    // Aggiungi il listener agli eventi del documento
    @HostListener('document:click', ['$event'])
    onClick(event: any) {
        // Verifica se il clic è avvenuto al di fuori del dropdown-menu aperto
        if (!event.target.closest('.dropdown-menu') && event.target.closest('.d-flex') === null) {
            this.showMenu = false;
        }
    }


    editAction(row: any) {
        let actionId = row.id;
        let campaignId = row.campaign_id;
        this.showMenu = false;
    
        // Controlla se action_type è definito e non è null
        let actionType = row.action_type ? row.action_type.trim() : '';
    
        // Gestione degli errori nel caso in cui actionType sia vuoto
        if (!actionType) {
            console.error('action_type is undefined or empty.'); // Log dell'errore
            // Puoi anche mostrare un messaggio all'utente, ad esempio un toast
            alert('Errore: il tipo di azione è vuoto o non definito.'); // Puoi usare un sistema di notifica migliore
            return; // Esci dalla funzione se actionType non è valido
        }
    
        if (actionType === "Coupon") {
            this.router.navigate(["/campaign-3", campaignId, actionId]);
        } else if (actionType === "Messaggio") {
            this.router.navigate(["/campaign-3", campaignId, actionId, "MSG"]);
        } else {
            console.warn(`Azione non riconosciuta: ${actionType}`); // Log per un'azione non riconosciuta
            alert(`Azione non riconosciuta: ${actionType}`); // Messaggio all'utente
        }
    }

    //si attiva quando clicco fuori dai bottoni 
    @HostListener('document:click', ['$event'])
    onClickOutside(event) {
        if (!event.target.closest('.d-flex')) {
            this.showMenu = false;
        }
    }

    fixDateFormat(date) {
        let returnValue;
        if (date) {
            var parts = date.split("-");
            var fixedDate = parts[2] + "/" + parts[1] + "/" + parts[0];
            returnValue = fixedDate;
        }
        else {
            returnValue = undefined;
        }
        return returnValue;
    }
    breadcrumbClicked(breadcrumb:BreadCrumbModel) {
        if (breadcrumb.routerLink) {
            this.router.navigate([breadcrumb.routerLink]);
          } else {
            console.log("nessuna route implementata");
          }
    }

    showCoupons(id: number) {
        this.actionStateService.setCurrentActionId(id);
        this.router.navigate(["/coupon-list-3/" + id]);
    }

    checkOnlyRead(row) {
        let retValue;
        if (this.language == "it"){
            retValue="Guarda Azione";
        }else{
            retValue="Open Action";
        }
      
       // let couponCheck = this.couponCheck(row);
        let dateCheck = this.dateCheck(row);
       /*  if (couponCheck && dateCheck) { */
       if (dateCheck) {
        if (this.language == "it"){
          retValue="Modifica Azione";
      }else{
          retValue="Edit Action";
      }
        }
        return retValue;
      }

    shouldDisable(row) {
        let retValue = false;
        let couponCheck = this.couponCheck(row);
        let dateCheck = this.dateCheck(row);
        if (couponCheck && dateCheck) {
            retValue = true;
        }
        return retValue;
    }

    couponCheck(row) {
        let retValue = false;
        let actionTypeCode = "CPN";
        let selectedValue = this.actionTypes.find(a => a.code === actionTypeCode);
        if (selectedValue && selectedValue.value == row.action_type_id) {
            retValue = true;
        }
        return retValue;
    }

    dateCheck(row) {
        let retValue = false;
        let campaign = this.campaignList.find(x => x.id == row.campaign_id);
        if (campaign) {
            let currentDate = new Date();
            let dateEndCampaign = new Date(campaign.end_date);

            if (currentDate < dateEndCampaign) {
                retValue = true;
            }
        }
        return retValue;
    }

    //cancellare azione 
    onDeleteAction_OLD(row: any) {

        let actionId = row.id;
        this.testService.deleteAction(actionId).subscribe(res => {
            this.kontableComponent.refresh();
        });


    }


    actionToDelete : any;
    displayDeleteDialog: boolean = false;
    onDeleteAction(row: any){
  
      console.log(row.status);
      this.displayDeleteDialog = true;
      this.actionToDelete=row;
  
     
     }
  
     closePopupDelete(){
      this.displayDeleteDialog = false;
     }

     onDefinitiveDelete(row: any) {
        let actionId = row.id;
        
        this.testService.deleteAction(actionId).subscribe(res => {
          console.log(res);
          this.displayDeleteDialog = false;
          this.kontableComponent.refresh();
        });
       
      }
  



}


// WEBPACK FOOTER //
// ./src/app/views/campaign-3/action-list-3/action-list-3.component.ts